<div class="wrapper">
  <mat-card [class.shadow-margin]="shadowMargin()">
    @if (showHeader()) {
      <mat-card-header>
        <mat-card-title>
          <div class="app-card__title">
            @if (title()) {
              <h3>
                {{ title() }}
              </h3>
            } @else if (subTitle()) {
              <h4 style="margin: 8px 0">
                {{ subTitle() }}
              </h4>
            }
            <div class="app-card__buttons">
              @if (displayCollarDeploymentInfographic()) {
                <mat-icon [mtxPopoverTriggerFor]="deploymentInfographic">info </mat-icon>
              }
              @for (button of headerIconButtons(); track button.icon) {
                @if (isSignal(button.doHide) ? !button.doHide() : !button.doHide) {
                  <div
                    [matTooltip]="
                      (button.isDisabled?.()
                        ? (isSignal(button.disabledHoverText)
                            ? button.disabledHoverText()
                            : button.disabledHoverText) ||
                          (isSignal(button.hoverText) ? button.hoverText() : button.hoverText)
                        : isSignal(button.hoverText)
                          ? button.hoverText()
                          : button.hoverText) || ''
                    "
                  >
                    <button
                      class="app-card__buttons"
                      mat-icon-button
                      [disabled]="button.isDisabled?.()"
                      (click)="button.onClick?.($event)"
                      [color]="button.color ?? 'primary'"
                      [style]="'color: ' + (button.color ?? 'primary')"
                    >
                      <mat-icon>{{ button.icon }}</mat-icon>
                    </button>
                  </div>
                }
              }
              <ng-template [ngTemplateOutlet]="cardButtons"></ng-template>
              @if (showResize()) {
                <button
                  mat-icon-button
                  (click)="onResize()"
                  [matTooltip]="isFullScreen ? 'Exit fullscreen' : 'Fullscreen'"
                  [color]="isFullScreen ? 'accent' : undefined"
                >
                  <mat-icon>
                    @if (!isFullScreen) {
                      fullscreen
                    } @else {
                      fullscreen_exit
                    }
                  </mat-icon>
                </button>
              }
              @if (displayClose()) {
                <button class="btn-close-icon" mat-icon-button (click)="onClose()">
                  <mat-icon [ngStyle]="subTitle() ? { fontSize: '1.3rem' } : null">{{
                    closeIcon()
                  }}</mat-icon>
                </button>
              }
              <mtx-popover #deploymentInfographic>
                @if (displayCollarDeploymentInfographic()) {
                  <img
                    class="deployment-infographic"
                    src="{{ collarDeploymentInfograficSrc }}"
                    alt="Collar deployment infographic"
                  />
                }
              </mtx-popover>
            </div>
          </div>
          <ng-content select="[header]"></ng-content>
          <hr />
        </mat-card-title>
      </mat-card-header>
    }

    <mat-card-content>
      <div class="card-body">
        <ng-content select="[body]"></ng-content>
      </div>
    </mat-card-content>

    <div class="card-footer">
      <ng-content select="[footer], mat-card-footer"></ng-content>
    </div>
  </mat-card>
</div>
